let core = null

export function createCore ({ store, router, i18n }) {
  // allow reinitialize in Jest testing framework only
  if (core && !process.env.JEST_WORKER_ID) {
    throw new Error('createCore has already been called')
  }

  const t = (...args) => {
    if (args.length > 1) {
      return i18n.global.tc(...args)
    }
    return i18n.global.t(...args)
  }

  const tc = (...args) => {
    return i18n.global.tc(...args)
  }

  const tm = (...args) => {
    return i18n.global.tm(...args)
  }

  const apiCall = (...args) => {
    if (args[0].url.match(/^\/loyalty-card-service\//)) {
      return store.dispatch('api/callLoyalty', ...args)
    } else if (args[0].url.match(/^\/hint-and-walkthrough\//)) {
      return store.dispatch('api/callHintAndWalkthrough', ...args)
    } else {
      return store.dispatch('api/call', ...args)
    }
  }

  core = {
    store,
    router,
    i18n,
    t,
    tc,
    tm,
    apiCall,
  }

  return core
}

export function useCore () {
  if (!core) {
    throw new Error('useCore called before createCore')
  }

  return core
}
